import FHIR from "fhirclient";
import { FHIR_ENTRYPOINT } from "../../config/api";

export const fhirClient = FHIR.client({
  serverUrl: FHIR_ENTRYPOINT.startsWith("http")
    ? FHIR_ENTRYPOINT
    : `${window.location.origin}${FHIR_ENTRYPOINT}`
});

